import React, { useState } from "react";
import { Container, Row, Col, Alert, Button } from "react-bootstrap";

const PhishingGame = () => {
  const [correctAnswers, setCorrectAnswers] = useState(0);
  const [wrongAnswers, setWrongAnswers] = useState(0);
  const [currentEmail, setCurrentEmail] = useState(null);
  const [feedback, setFeedback] = useState(null);

  const emails = [
    {
      id: "safe01",
      type: "safe",
      initials: "IT",
      name: "IT-Support",
      email: "it-support@unternehmen.de",
      subject: "RE: Systemwartung",
      content: `
        <p>Liebe Kolleginen und Kollegen,</p> <p>am Donnerstag, den 15.12.2024, führen wir zwischen 18:00 und 22:00 Uhr unsere routinemäßige Systemwartung durch. In dieser Zeit kann es zu kurzen Unterbrechungen der IT-Systeme kommen.</p> <p>Bei dringenden Fragen erreichen Sie uns unter der Durchwahl 2345.</p> <p>Mit freundlichen Grüßen<br>Euer IT-Support Team</p>
      `,
      date: "heute",
      explanation: {
        safe: "Dies ist eine legitime E-Mail. Merkmale:\n- Interne Support-Adresse\n- Konkrete Zeitangaben\n- Keine dringenden Handlungsaufforderungen\n- Erreichbarkeit über interne Durchwahl",
        phishing:
          "Diese E-Mail ist sicher. Achte auf:\n- Offizielle IT-Support Adresse\n- Planmäßige Wartungsankündigung\n- Keine Links oder Anhänge\n- Erreichbarkeit über interne Kanäle",
      },
    },
    {
      id: "phish01",
      type: "phishing",
      initials: "MS",
      name: "Microsoft 365",
      email: "security@microsoft-verify.com",
      subject: "DRINGEND: Ihr Konto wurde eingeschränkt",
      content: `
            <p>Sehr geehrter Nutzer,</p>
            <p>Wir haben verdächtige Anmeldeaktivitäten in Ihrem Microsoft 365-Konto festgestellt. Ihr Konto wurde vorübergehend eingeschränkt.</p>
            <p>Klicken Sie hier, um Ihr Konto zu entsperren: <a href="#">https://microsoft-verify.com/unlock</a></p>
            <p>Microsoft Security Team</p>
          `,
      date: "heute",
      explanation: {
        safe: "Dies ist eine Phishing-Mail. Warnsignale:\n- Gefälschte Microsoft-Domain\n- Dringlichkeitsformel\n- Verdächtiger Link\n- Unpersönliche Anrede",
        phishing:
          "Typische Phishing-Merkmale:\n- Nicht authentische Microsoft-Domain\n- Druck durch 'DRINGEND'im Betreff\n- Verdächtiger Link zur Kontoentsperre\n- Generische Anrede",
      },
    },
    {
      id: "safe02",
      type: "safe",
      initials: "PL",
      name: "Petra Lange",
      email: "p.lange@unternehmen.de",
      subject: "RE: Teammeeting Protokoll",
      content: `
          <p>Hallo Team,</p>
          <p>im Anhang findet ihr das Protokoll unseres gestrigen Teammeetings. Bitte prüft eure Aufgaben und To-Dos für die nächste Woche.</p>
          <p>Das nächste Meeting findet am Montag um 10.00 Uhr im Raum 301 statt.</p>
          <p>Viele Grüße<br>Petra</p>
        `,
      date: "heute",
      explanation: {
        safe: "Dies ist eine legitime E-Mail. Merkmale:\n- Bekannte interne Absenderin\n- Bezug auf konkretes Meeting\n- Normale geschäftliche Kommunikation\n- Spezifische Raumangabe",
        phishing:
          "Diese E-Mail ist sicher. Achten Sie auf:\n- Interne Absenderadresse\n- Konkreter Meetingbezug\n- Übliche Teamkommunikation\n- Keine verdächtigen Elemente",
      },
    },
    {
      id: "phish02",
      type: "phishing",
      initials: "HR",
      name: "HR-Portal",
      email: "hr@company-portal-login.net",
      subject: "Wichtig: Jahresbonus 2024",
      content: `
            <p>Liebe/r Mitarbeiter/in,</p>
            <p>Ihr Jahresbonus 2024 wurde berechnet. Bitte loggen Sie sich innerhalb der nächsten 24 Stunden ein, um Ihren Bonus zu bestätigen.</p>
            <p>Zum HR-Portal: <a href="#">https://hr-portal-login.net/bonus</a></p>
            <p>Mit freundlichen Grüßen<br>HR-Team</p>
          `,
      date: "heute",
      explanation: {
        safe: "Dies ist eine Phishing-Mail. Warnsignale:\n- Verdächtige HR-Portal Domain\n- Zeitdruck\n- Verlockender Bonus\n- Unpersönliche Anrede",
        phishing:
          "Phishing-Merkmale:\n- Gefälschte HR-Portal Adresse\n- Dringlichkeit durch Zeitlimit\n- Verlockung durch Bonus\n- Generische Anrede",
      },
    },
    {
      id: "safe03",
      type: "safe",
      initials: "MK",
      name: "Michael Klein",
      email: "m.klein@unternehmen.de",
      subject: "RE: Projektbudget Q1",
      content: `
          <p>Hallo Sandra,</p>
          <p>danke für deine Anfrage. Die aktualisierten Budgetzahlen für Q1 2025 findest du im SharePoint unter Projekte/Budget/2025.</p>
          <p>Lass uns morgen in der Kaffeepause kurz darüber sprechen.</p>
          <p>Beste Grüße<br>Michael</p>
        `,
      date: "heute",
      explanation: {
        safe: "Dies ist eine legitime E-Mail. Merkmale:\n- Interner Kollege als Absender\n- Verweis auf interne Systeme\n- Persönliche Ansprache\n- Natürlicher Kommunikationsstil",
        phishing:
          "Diese E-Mail ist sicher. Achte auf:\n- Firmeninterne E-Mail-Adresse\n- Verweis auf bekannte Systeme\n- Konkreter Arbeitskontext\n- Persönlicher Austausch",
      },
    },
    {
      id: "phish03",
      type: "phishing",
      initials: "IT",
      name: "IT Support",
      email: "support@it-helpdesk-service.ru.com",
      subject: "Neue Datenschutzrichtlinien - Sofortige Aktion erforderlich",
      content: `
          <p>Sehr geehrte/r Mitarbeiter/in,</p>
          <p>Aufgrund neuer Datenschutzrichtlinien müssen alle Mitarbeiter Ihr Passwort sofort ändern. Bei Nichteinhaltung wird Ihr Zugang gesperrt.</p>
          <p>Zum Passwort-Reset: <a href="#">https://password-reset-service.com</a></p>
          <p>IT Support Team</p>
        `,
      date: "heute",
      explanation: {
        safe: "Dies ist eine Phishing-Mail. Warnsignale:\n- Externe Support-Domain\n- Drohung mit Sperrung\n- Verdächtiger Link\n- Unpersönliche Anrede",
        phishing:
          "Phishing-Merkmale:\n- Nicht autorisierte IT-Support Domain\n- Drohung und Zeitdruck\n- Verdächtiger Passwort-Reset Link\n- Fehlende persönliche Anrede",
      },
    },

    {
      id: "phish02",
      type: "phishing",
      initials: "DHL",
      name: "DHL-Portal",
      email: "dhl@delivery-portal-login.net",
      subject: "Neue Versandaktualisierung: Ihre Kundennummer 78923243",
      content: `
          <p>Hallo lieber Kunde,</p>
          <p>danke, dass Sie sich für uns entschieden haben. Um Ihr Paket liefern zu können, bitte wir Sie, unsere Anweisungen zu befolgen. Klicken Sie bitte auf den unten stehenden Button, um auf unsere Seite weitergeleitet zu werden, und befolgen Sie die dort angegebene Anweisung. </p> 
          <p> <a href="#">VOLLSTÄNDIGER VERSAND HIER</a></p><p>Bitte beachten Sie, dass der Link nur 48 Stunden gültig ist.</p>
         
        `,
      date: "heute",
      explanation: {
        safe: "Dies ist eine Phishing-Mail. Warnsignale:\n- Verdächtige Portal-Domain\n- Zeitdruck\n- Verdächtiger Button\n- Unpersönliche Anrede",
        phishing:
          "Phishing-Merkmale:\n- Gefälschte DHL-Portal Adresse\n- Dringlichkeit durch Zeitlimit\n- Leichter Zugang durch direkten Link\n- Generische Anrede",
      },
    },

    {
      id: "phish04",
      type: "phishing",
      initials: "DH",
      name: "DocuHub",
      email: "notification@docuhub-secure.net",
      subject: "Sie haben ein wichtiges Dokument erhalten",
      content: `
          <p>Hallo,</p>
          <p>Ein vertrauliches Dokument wurde für Sie freigegeben. Das Dokument ist nur noch 24 Stunden verfügbar.</p>
          <p>Dokument ansehen: <a href="#">https://docuhub-secure.net/document/view</a></p>
          <p>DocuHub Team</p>
        `,
      date: "heute",
      explanation: {
        safe: "Dies ist eine Phishing-Mail. Warnsignale:\n- Unbekannter Dokumentendienst\n- Zeitdruck durch Verfallsdatum\n- Verdächtiger Link\n- Vage Dokumentbeschreibung",
        phishing:
          "Phishing-Merkmale:\n- Gefälschter Dokumentendienst\n- Künstliche Dringlichkeit\n- Verdächtiger Download-Link\n- Unspezifische Angaben",
      },
    },
    {
      id: "phish05",
      type: "phishing",
      initials: "AM",
      name: "Amazon Prime",
      email: "service@amazon-prime-verify.com",
      subject: "Ihre Amazon Prime Mitgliedschaft wurde pausiert",
      content: `
          <p>Sehr geehrter Amazon Prime Kunde,</p>
          <p>Wir konnten Ihre letzte Zahlung nicht verarbeiten. Ihre Prime-Mitgliedschaft wurde vorübergehend pausiert.</p>
          <p>Aktualisieren Sie Ihre Zahlungsinformationen hier: <a href="#">https://amazon-prime-verify.com/update</a></p>
          <p>Amazon Prime Team</p>
        `,
      date: "heute",
      explanation: {
        safe: "Dies ist eine Phishing-Mail. Warnsignale:\n- Gefälschte Amazon-Domain\n- Zahlungsaufforderung\n- Verdächtiger Link\n- Drohung mit Sperrung",
        phishing:
          "Phishing-Merkmale:\n- Nicht authentische Amazon-Domain\n- Druck durch angebliche Sperrung\n- Verdächtiger Zahlungslink\n- Typisches Betrugsmuster",
      },
    },
  ];

  const handleEmailAction = (isPhishingReport) => {
    if (!currentEmail) return;

    const isCorrect =
      (isPhishingReport && currentEmail.type === "phishing") ||
      (!isPhishingReport && currentEmail.type === "safe");

    if (isCorrect) {
      setCorrectAnswers((prev) => prev + 1);
      setFeedback({
        type: "success",
        message: currentEmail.explanation[currentEmail.type],
      });
    } else {
      setWrongAnswers((prev) => prev + 1);
      setFeedback({
        type: "danger",
        message:
          currentEmail.explanation[isPhishingReport ? "safe" : "phishing"],
      });
    }
  };

  const resetGame = () => {
    setCorrectAnswers(0);
    setWrongAnswers(0);
    setCurrentEmail(null);
    setFeedback(null);
  };

  return (
    <Container fluid className="p-2 bg-light phishing">
      <h4 className="p-3 text-center">Phishing-Game</h4>
      <div className="email-client bg-light">
        <header className="email-header bg-light d-flex justify-content-between align-items-center p-3 border-bottom">
          <div className="d-flex gap-3">
            <button
              className="btn btn-danger"
              onClick={() => handleEmailAction(true)}
              disabled={!currentEmail}
            >
              Phishing
            </button>
            <button
              className="btn btn-success"
              onClick={() => handleEmailAction(false)}
              disabled={!currentEmail}
            >
              Kein Phishing
            </button>
          </div>
          <div className="score-container d-flex gap-4">
            <div className="correct-score bg-white text-success fw-medium px-4 py-2 border rounded">
              <span className="scorex me-2">{correctAnswers}</span>
              <span className="text-success">Richtig</span>
            </div>
            <div className="wrong-score bg-white text-danger fw-medium px-4 py-2 border rounded">
              <span className="scorex me-2">{wrongAnswers}</span>
              <span className="text-danger">Falsch</span>
            </div>
          </div>
        </header>

        {feedback && (
          <Alert
            variant={feedback.type}
            onClose={() => setFeedback(null)}
            dismissible
            className="m-3"
          >
            <Alert.Heading>
              {feedback.type === "success" ? "Richtig!" : "Falsch!"}
            </Alert.Heading>
            <p className="white-space-pre-line">{feedback.message}</p>
          </Alert>
        )}

        <Row className="g-0">
          <Col md={2} className="border-end">
            <div className="sidebar p-2">
              <div className="folder active d-flex align-items-center p-2 rounded">
                <i className="fas fa-inbox me-2"></i>
                Inbox{" "}
                <span className="ms-auto badge bg-success rounded-pill">8</span>
              </div>
              <div className="folder d-flex align-items-center p-2">
                <i className="fas fa-exclamation-circle me-2"></i>
                Junk Email
              </div>
              {/* Weitere Ordner hier */}
            </div>
          </Col>

          <Col md={4} className="border-end">
            <div className="email-list">
              <h6 className="p-3 border-bottom m-0">Inbox</h6>
              {emails.map((email) => (
                <div
                  key={email.id}
                  className={`email-item p-3 border-bottom ${
                    currentEmail?.id === email.id ? "active bg-light" : ""
                  }`}
                  onClick={() => setCurrentEmail(email)}
                >
                  <div className="d-flex align-items-center">
                    <div className="initials-circle me-3">{email.initials}</div>
                    <div className="flex-grow-1">
                      <div className="fw-bold">{email.name}</div>
                      <div className="text-muted small">{email.subject}</div>
                    </div>
                    <div className="text-muted small ms-2">{email.date}</div>
                  </div>
                </div>
              ))}
            </div>
          </Col>

          <Col md={6}>
            {currentEmail ? (
              <div className="email-content p-4">
                <div className="email-header mb-4">
                  <div className="d-flex align-items-center">
                    <div className="initials-circle me-3">
                      {currentEmail.initials}
                    </div>
                    <div className="flex-grow-1">
                      <div className="fw-bold">{currentEmail.name}</div>
                      <div className="text-muted">{currentEmail.email}</div>
                    </div>
                    <div className="text-muted">{currentEmail.date}</div>
                  </div>
                </div>
                <div
                  className="email-body"
                  dangerouslySetInnerHTML={{ __html: currentEmail.content }}
                ></div>
              </div>
            ) : (
              <div className="p-4 text-center text-muted">
                Klicke auf die Mails und teste deine Security Awareness.
              </div>
            )}
          </Col>
        </Row>

        <div className="text-center mt-4 mb-4">
          <Button
            variant="primary"
            size="lg"
            onClick={resetGame}
            className="restart-button"
          >
            Test neu starten
          </Button>
        </div>
      </div>
    </Container>
  );
};

export default PhishingGame;
